import { gql } from "@apollo/client";

export const FAVORITE_TRIP_MUTATION = gql`
      mutation FavoriteTrip($input: FavoriteTripInput!){
        favoriteTrip(input: $input) {
          success
        }
      }
    `;
